<!-- 主页面 -->
<template>
  <div class="tx-main">
    <TxImage src="img_logo" class="logo s-sub-4" />
    <div class="f-column buy f-center">
      <TxContainer src="img_biaoti_1" class="m-sub-80"></TxContainer>
      <TxContainer src="img_biaoti" class="m-sub-15"></TxContainer>
      <TxContainer src="img_xx_db">
        <div class="p-r">
          <TxAccount />
          <span class="end-time"
            >{{
              get_time_year_month_day(product_end_time * 1000)
            }}停止抢购</span
          >
        </div>
        <div class="p-r">
          <div class="f-row f-zhu-center m-30 buy-name">
            当前可购买礼包服务器
            <TxContainer src="btn_xiala_dwn" class="f-center m-t-10 m-l-10">
              <select
                v-if="server_list"
                class="select"
                v-model="test_server_id"
                @change="server_confirm"
              >
                <option
                  v-for="item in server_list"
                  :value="item.value"
                  :key="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </TxContainer>
          </div>
        </div>
        <div class="f-center w-100 m-t-30 buy-btn">
          <TxButton
            src="btn_gm_nml_1"
            name="点击购买"
            v-if="status !== 4 && !product_discount.includes(test_server_id)"
            @click="handle_start_buy"
          ></TxButton>
          <TxButton
            src="discount"
            name="点击购买"
            v-else-if="
              status !== 4 && product_discount.includes(test_server_id)
            "
            @click="handle_start_buy"
          ></TxButton>
          <TxButton src="btn_gm_dis_1" v-else></TxButton>
          <span @click="handle_open_order" class="m-t-5 dingdan">查看订单</span>
        </div>
        <footer>
          <!-- <h3>购买说明</h3> -->
          <TxContainer class="center m-t-10 m-b-10" src="img_zi"></TxContainer>
          <p>
            1
            .新服特权礼包无需创建角色即可直接购买，每个账号在每个服务器限购一次
          </p>
          <p>
            2
            .购买成功后，绿色通道排队特权即刻生效。该特权以账号为单位生效，账号下所有角色均可享受排队特权
          </p>
          <p>3 .购买成功后，云游戏时间即刻生效</p>
          <p>
            4 .礼包内含的时装和珍兽奖励，需创角进入游戏后领取，每个账号仅限领取
            1 次
          </p>
          <p>
            5 .自动任务权益对帐号下所有角色生效，拥有该权益可无视 1
            万人物修为要求，在万象客户端直接自动完成师门、快马加鞭、诗与酒、童趣等日常任务。
          </p>
          <p>
            6 .该礼包为天下贰经典版公测开服特惠礼，时装和坐骑永不返场，限时售卖
          </p>
        </footer>
      </TxContainer>
    </div>

    <TxDialog v-model="dialog.step_1" :closeOnClickOverlay="false">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">确认账号</div>
        <div class="dialog-content f-center">
          <div class="f-row item">
            <div>通行证</div>
            <div class="dialog-name t-center">{{ user.activeUrs }}</div>
          </div>
          <div class="f-row item">
            <div>服务器</div>
            <div class="dialog-server t-center server-color">
              {{ server[test_server_id] }}
            </div>
          </div>
          <div class="tips">
            购买后解锁【{{ server[test_server_id] }}】新服特权礼包<br />
            享 <span class="lvtong">登录绿通特权</span>，优先进服
          </div>
        </div>

        <div class="f-center p-r dialog-footer">
          <TxButton src="goumai" name="确认购买" @click="handle_buy_step_2" />
          <span name="我在想想" class="think" @click="dialog.step_1 = false"
            >我再想想</span
          >
        </div>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="dialog.step_2" :closeOnClickOverlay="false">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">支付订单</div>
        <div class="dialog-content f-center">
          <span
            v-if="!product_discount.includes(test_server_id)"
            class="product_price"
            >¥{{ product_price }}</span
          >
          <span v-else class="product_price">¥{{ server_discount_price }}</span>
          <TxButton
            src="weixin"
            class="m-t-40"
            name="微信支付"
            @click="throttledClick('weixinpay')"
          />
          <TxButton
            src="zhifubao"
            class="m-t-20"
            name="支付宝购买"
            @click="throttledClick('alipay')"
          />
        </div>
        <div class="f-center p-r dialog-footer">
          <span class="back" @click="handle_step_2_1">返回上一步</span>
        </div>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="dialog.step_3">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">支付订单</div>
        <div class="dialog-content f-center p-r">
          <TxImage src="zi" class="success" />
          <span class="success-info">
            订单刷新稍有延迟<br />
            <span
              >请在<span class="server-color m-10">1分钟后</span
              >,查看订单状态</span
            >
          </span>
        </div>
        <div class="f-center p-r dialog-footer">
          <TxButton
            src="queren"
            name="确认（支付成功关闭）"
            @click="handle_close"
          />
        </div>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="dialog.step_4">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">购买信息</div>
        <div class="dialog-content f-center">
          <div class="f-row item">
            <div>通行证</div>
            <div class="dialog-name t-center">{{ user.activeUrs }}</div>
          </div>
          <div class="f-row item">
            <div>服务器</div>
            <div class="dialog-server t-center server-color">
              {{ server[test_server_id] }}
            </div>
          </div>
          <div class="tips f-row">
            <div class="order-left f-column">
              <span>新服特权礼包</span>
              <span>{{ order_time }}</span>
            </div>
            <div class="t-center m-l-20">
              <span v-if="status == 4" class="green">支付成功</span>
              <span v-else-if="status == 0" class="red">待支付</span>
              <span v-else-if="status == 1" class="green">正在支付</span>
              <span v-else class="red">支付失败</span>
            </div>
          </div>
        </div>

        <div class="f-center p-r dialog-footer">
          <TxButton
            src="queren"
            name="关闭订单"
            @click="dialog.step_4 = false"
          />
        </div>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="dialog.step_5">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">微信支付</div>
        <div class="dialog-content f-center m-t-10">
          <QrcodeVue :size="280" :value="wx_pay.qrcode" />
        </div>
        <div class="f-center p-r dialog-footer t-white">
          <span>请使用微信扫码支付</span>
          <TxButton src="btn_an_ovr" class="has-buy" @click="handle_check"
            >我已支付</TxButton
          >
          <span class="t-red"
            ><nut-countdown
              :start-time="Date.now()"
              :end-time="wx_pay.expired_time * 1000"
              @end="dialog.step_5 = false"
            ></nut-countdown
          ></span>
        </div>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="dialog.step_6">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">继续付款</div>
        <div class="dialog-content f-center">
          <div class="f-row item">
            <div>通行证</div>
            <div class="dialog-name t-center">{{ user.activeUrs }}</div>
          </div>
          <div class="f-row item">
            <div>服务器</div>
            <div class="dialog-server t-center server-color">
              {{ server[test_server_id] }}
            </div>
          </div>
          <div class="tips">
            购买后解锁【{{ server[test_server_id] }}】新服特权礼包<br />
            享 <span class="lvtong">登录绿通特权</span>，优先进服
          </div>
        </div>
        <div class="f-center p-r dialog-footer">
          <TxButton name="继续支付" @click="handle_continue_pay" src="goumai" />
        </div>
      </TxContainer>
    </TxDialog>
  </div>
</template>

<script setup>
import eventEmitter from '@utils/event';
const { user, channel } = inject('GlobalStore');
import { onMounted, reactive, shallowRef } from 'vue';
import { useThrottleFn } from '@vueuse/core';
import { firstLog } from '../utils/log';
import { get_server_list } from '../utils/api';
import { get_time_year_month_day } from '@utils/time';
import QrcodeVue from 'qrcode.vue';
const project = 'tx2_oldclassic';
const h5_tag = 50;
let test_server_id = ref('');
const status = shallowRef(null);
class JellyOrderStatus {
  static INIT = 0;
  static ON_PAY = 1;
  static TIMEOUT = 2;
  static PAY_FAIL = 3;
  static PAY_SUCCESS = 4;
}
// 订单状态
const product_id = shallowRef('g20.jd.lstd.1005610');
const product_price = shallowRef(null);
const order_id = shallowRef(null);
const order_time = shallowRef(null);
const product_end_time = shallowRef(null);
const product_discount = ref([]);
const server_discount_price = shallowRef(null);
const dialog = reactive({
  step_1: false,
  step_2: false,
  step_3: false,
  step_4: false,
  step_5: false,
  step_6: false,
});

const wx_pay = reactive({
  expired_time: '',
  qrcode: '',
});

const server = {};

let server_list = ref(null);

function handlerPayGetProductList(project, h5_tag, server_id) {
  window.h5sdk.core
    .PayGetProductList(project, h5_tag, server_id)
    .then((res) => {
      if (res.code === 1) {
        product_id.value = res.data[0].productid;
        product_price.value = res.data[0].price;
        product_end_time.value = res.data[0].sale_end;
        product_discount.value = res.data[0].discounted_serverlist;
        server_discount_price.value = res.data[0].server_discount_price;
      } else {
        console.error('查询商品失败：', res);
      }
    });
}

function handle_start_buy() {
  if (user.value.isLoggedIn) {
    if (status.value == 0) {
      dialog.step_6 = true;
    } else {
      dialog.step_1 = true;
    }
  } else {
    eventEmitter.emit('login');
  }
}
function handle_buy_step_2() {
  if (channel.channel == 'wx') {
    throttledClick('weixinpay');
  } else {
    dialog.step_1 = false;
    dialog.step_2 = true;
  }
}

function handle_step_2_1() {
  dialog.step_2 = false;
  dialog.step_1 = true;
}

async function handle_pay(pay_method) {
  let pay_mode = null;
  if (pay_method == 'weixinpay') {
    pay_mode = 'qrcode';
  } else {
    pay_mode = 'pc';
  }
  console.log(pay_method, pay_mode);
  let price = product_price.value;
  if (product_discount.value.includes(test_server_id.value)) {
    price = server_discount_price.value;
  }
  window.h5sdk.core
    .PayCreateOrder({
      project: project,
      urs: user.value.activeUrs,
      account_id: user.value.activeUrsAccount.account,
      productid: product_id.value,
      product_price: price,
      product_count: 1,
      role_id: '',
      rolename: '',
      server_id: test_server_id.value,
      server_name: '',
      pay_method: pay_method,
      pay_mode: pay_mode,
    })
    .then((res) => {
      if (res.code == 1) {
        if (pay_method == 'weixinpay') {
          wx_pay.qrcode = res.data.pay_url;
          wx_pay.expired_time = res.data.expired_time;
          order_id.value = res.data.order_id;
          dialog.step_5 = true;
        }
      }
    });
}
const throttledClick = useThrottleFn(handle_pay, 1000);

// 查询自己身上的订单
async function get_order_list() {
  let res = await window.h5sdk.api.h5PayOrdersList({
    project: 'tx2_oldclassic',
    h5_tag: h5_tag,
    page: 1,
    page_size: 1,
    productid: product_id.value,
    status_in: [0, 1, 4],
    sort: 'status',
    server_id: test_server_id.value,
  });
  if (res.code === 1) {
    let data = res.data.orders;
    if (data.length > 0) {
      status.value = data[0].status;
      order_id.value = data[0].id;
      order_time.value = data[0].create_time;
      if (
        status.value === JellyOrderStatus.INIT ||
        status.value === JellyOrderStatus.ON_PAY
      ) {
        // 查询是否为支付返回进入H5页面
        const returnPayParams = window.h5sdk.core.PayGetReturnPayParams();
        console.log('支付返回：' + JSON.stringify(returnPayParams));
        if (!returnPayParams) {
          if (status.value == 0) {
            dialog.step_6 = true;
          }
          if (status.value === JellyOrderStatus.ON_PAY) {
            window.h5sdk.core.PayWait(order_id.value).then((res) => {
              console.log('PayWait', res);
              if (!res.data) {
                if (status.value == 0) {
                  dialog.step_6 = true;
                }
              }
              order_id.value = res.data.order_id;
              status.value = res.data.status;
              order_time.value = res.data.create_time;
              if (status.value === JellyOrderStatus.PAY_SUCCESS) {
                dialog.step_3 = true;
              }
            });
          }
          return;
        }
        // 去查询支付状态
        window.h5sdk.core.PayWait(returnPayParams.order_id).then((res) => {
          console.log('PayWait', res);
          if (!res.data) {
            if (status.value == 0) {
              dialog.step_6 = true;
            }
            return;
          }
          order_id.value = res.data.order_id;
          status.value = res.data.status;
          order_time.value = res.data.create_time;
          if (status.value === JellyOrderStatus.PAY_SUCCESS) {
            dialog.step_3 = true;
            dialog.step_6 = false;
          }
        });
      }
      if (status.value == 4) {
        dialog.step_3 = true;
      }
    } else {
      status.value = null;
      order_id.value = null;
      order_time.value = null;
    }
  }
}

function start_query_pay() {
  window.h5sdk.core.QueryPayStatus(order_id.value).then((res) => {
    if (res.code === 1) {
      status.value = res.data.status;
    }
  });
}
async function handle_continue_pay() {
  await start_query_pay();
  if (status.value == 0) {
    // 走付款逻辑，不需要下订单
    const res = await window.h5sdk.core.PayRetryPayment(order_id.value);
    if (
      res.code == 1 &&
      res.data.pay_method == 'weixinpay' &&
      res.data.pay_mode == 'qrcode'
    ) {
      wx_pay.qrcode = res.data.pay_url;
      wx_pay.expired_time = res.data.expired_time;
      dialog.step_5 = true;
      dialog.step_6 = false;
    }
    return;
  }
}

async function onVisible() {
  console.log('返回visible');
  const returnPayParams = window.h5sdk.core.PayGetReturnPayParams();
  console.log('returnPayParams', returnPayParams);
  if (!returnPayParams) return;
  if (status.value == 0) {
    dialog.step_6 = true;
  }
  window.h5sdk.core.PayWait(returnPayParams.order_id).then((res) => {
    console.log('PayWait', res);
    if (!res.data) return;
    order_id.value = res.data.order_id;
    status.value = res.data.status;
    order_time.value = res.data.create_time;
    if (status.value === JellyOrderStatus.PAY_SUCCESS) {
      dialog.step_2 = false;
      dialog.step_3 = true;
      dialog.step_6 = false;
    }
  });
}

function handle_close() {
  dialog.step_3 = false;
  eventEmitter.emit('launch');
}

onMounted(async () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      onVisible();
    }
  });
  const res = await get_server_list('tx2_oldclassic', h5_tag);
  if (res.code == 1) {
    let columns = [];
    res.data.forEach((element) => {
      server[element.server_id] = element.server_name;
      columns.push({
        text: element.server_name,
        value: element.server_id,
      });
    });
    server_list.value = columns;
    test_server_id.value = window.h5sdk.core.getEnterPaySaleServerId();
    if (!test_server_id.value) {
      test_server_id.value = server_list.value[0].value;
    }
    handlerPayGetProductList(project, h5_tag, test_server_id.value);
    // if(user.value.isLoggedIn){
    //   handlerPayGetProductList(project, h5_tag, test_server_id.value);
    // }
  } else {
    eventEmitter.emit('toast', {
      text: '查询服务器失败，请重试！',
    });
  }
});

async function handle_open_order() {
  let res = await window.h5sdk.api.h5PayOrdersList({
    project: 'tx2_oldclassic',
    h5_tag: h5_tag,
    page: 1,
    page_size: 1,
    productid: product_id.value,
    status_in: [0, 1, 4],
    sort: 'status',
    server_id: test_server_id.value,
  });
  if (res.code == 1) {
    let data = res.data.orders;
    if (data.length > 0) {
      status.value = data[0].status;
      order_id.value = data[0].id;
      order_time.value = data[0].create_time;
      dialog.step_4 = true;
    } else {
      eventEmitter.emit('toast', {
        text: '当前没有订单，请少侠先购买礼包',
      });
    }
  }
}

watch(user, (v) => {
  if (v.isLoggedIn) {
    get_order_list();
    firstLog(true);
  } else {
    firstLog(false);
  }
});

watch(test_server_id, (v) => {
  if (user.value.isLoggedIn) {
    get_order_list();
  }
});

async function server_confirm() {
  if (user.value.isLoggedIn) {
    window.h5sdk.core.setEnterPaySaleServerId(test_server_id.value);
    get_order_list();
  } else {
    eventEmitter.emit('login');
  }
}

async function handle_check() {
  window.h5sdk.core.QueryPayStatus(order_id.value).then((res) => {
    console.log('PayWait', res);
    if (res.code == 1) {
      if (res.data.status == 0) {
        eventEmitter.emit('toast', {
          text: '订单未支付',
        });
      } else if (res.data.status == 2) {
        eventEmitter.emit('toast', {
          text: '订单支付超时',
        });
      } else if (res.data.status == 4) {
        eventEmitter.emit('toast', {
          text: '订单支付成功',
        });
        dialog.step_5 = false;
        dialog.step_3 = true;
      } else if (res.data.status == 3) {
        eventEmitter.emit('toast', {
          text: '订单支付失败',
        });
      }
    }
  });
}
</script>
<style lang="scss" scoped>
.tx-main {
  position: relative;
  overflow: hidden;
  width: 100% !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  min-height: 1080px;
  height: var(--fullHeight);
  background-image: url('https://g20.gsf.netease.com/20260108-101129/img_db.png');
}
.launcher {
  position: absolute;
  right: 30px;
  top: 330px;
}

.btn-tips {
  position: absolute;
  right: 200px;
  top: -15px;
}

.dialog-tips {
  width: 100%;
  height: 40px;
  color: white;
  font-weight: bold;
  // line-height: 70px;
  position: relative;
  top: -10px;
}

.dialog-content {
  height: 310px;
  width: 100%;
  color: white;
}

.dialog-footer {
  height: 130px;
  width: 100%;
}

.think {
  position: absolute;
  left: 130px;
  font-size: 23px;
  text-decoration: underline;
  color: white;
}

.dialog-name {
  color: #ffcd5c !important;
  @include bg('shurukuang');
  text-align: left;
  padding-left: 20px;
}

.dialog-server {
  color: #ffcd5c !important;
  @include bg('shurukuang');
  text-align: left;
  padding-left: 20px;
}

.dialog-names {
  width: 380px;
  height: 200px;
  position: relative;
  left: 70px;
}

.time {
  position: relative;
  top: 40px;
  left: 75px;
}

.order-left {
  color: white;
}

.server {
  position: relative;
  left: 180px;
  top: -8px;
  color: #958871;
}

.server-color {
  color: #ffcd5c;
}

.no-server {
  color: #958871;
  position: absolute;
  left: 275px;
  top: 125px;
}

.tu {
  margin: -10px 0;
}

.buy-name {
  color: #00336f;
  position: relative;
  top: -10px;
}

.dingdan {
  font-size: 20px;
  text-decoration: underline;
  color: #e2c88f94;
  position: relative;
  left: 170px;
  top: -50px;
}

footer {
  color: white;
  padding-left: 50px;
  padding-right: 50px;
  font-size: 13px;
  position: relative;
  top: 530px;

  & p {
    text-align: left;
  }
}

.item {
  width: 500px;
  align-items: center;

  div {
    // width: 200px;
    color: white;
  }
}

.lvtong {
  color: #ffcd5c;
}

.tips {
  font-size: 25px;
  color: white !important;
  text-align: center;
  margin-top: 30px;
}

.product_price {
  color: #eb5e5b;
  font-size: 60px;
  transform: scale(1.5);
  position: relative;
  top: 10px;
}

.back {
  color: white;
  text-decoration: underline;
  font-size: 25px;
}

.buy {
  position: absolute;
  right: 200px;
}
.select {
  display: flex;
  font-size: 20px;
  padding: 0px 10px;
  color: #ffcd5c;
  appearance: none;
  outline: none;
  border: none;
  background-color: transparent;
  position: relative;
  width: 274px;
  height: 29px;
}

option {
  // background-color: #00336f;
  color: #00336f;
}

// option:checked {
//   background-color: #00336f;
//   color: #a76c44;
// }

// option:hover {
//   background-color: #00336f;
//   color: #a76c44;
// }
.buy-btn {
  position: absolute;
  top: 736px;
}
.success {
  position: absolute;
  transform: scale(0.4);
  top: -40px;
}
.success-info {
  position: absolute;
  top: 210px;
  text-align: center;
}
.logo {
  position: absolute;
  left: -30px;
  top: -80px;
}
.has-buy {
  font-size: 20px;
  color: black;
}
.center {
  position: relative;
  left: 100px;
}
.end-time {
  position: absolute;
  top: 20px;
  right: 40px;
  font-size: 15px;
  color: #ffcd5c;
}
</style>
